import { Named } from '../base/named';
import { } from '../base/annotation';
import { Copier } from '../base/copier';
import { Metamodel } from '../base/model';

/*
  Purpose of this class is to have a shadow so that cancel operations can be
  done to dirty objects without refetching them. For now, it is primarily used with rename
*/
export class Shadow {
    /*
        Casts a shadow the object and returns that shadow
    */
    public static cast<T extends Named>(context: { inlineDataset?: boolean }, named: T): T {
        // Essentially we need to make a copy of the name onto an object
        // we already have
        if (!named.extension.$shadow) {
            named.extension.$shadow = Metamodel.modelOf(named).create();
        }
        const shadow = named.extension.$shadow as T;
        Copier.clone(context, [named], [shadow], false, true);

        return shadow;
    }

    /*
        Reflects the shadow back onto the same object. Reverse of cast
    */
    public static reflect<T extends Named>(context: { inlineDataset?: boolean }, named: T): T {
        // Essentially we need to make a copy of the name onto an object
        // we already have
        if (!named.extension.$shadow) {
            return named;
        }
        const shadow = named.extension.$shadow as T;
        Copier.clone(context, [shadow], [named], false, true);

        return named;
    }

    /*
        Prior incarnation of the object if any
    */
    public static shadow<T extends Named>(named: T): T | undefined {
        return named.extension.$shadow as T;
    }
}
